import { Accordion } from '@mantine/core';
import { Suspense, useState } from 'react';

import { MinStdItemYearGathering } from '@/module/MinimalStandard/components/MinStdItemYearGathering';

import { PendingSpinner } from '@/core/components';

import { Id } from '@/feature/utils';

import { Indicator } from '../model/MinStdTypes';

interface MinStdIndicatorGatheringProps {
  indicator: Indicator;
  authorId: Id;

  startYear: number;
  endYear: number;
}

function range(start: number, end: number) {
  return Array.from(Array(end - start + 1).keys()).map((_, idx) => start + idx);
}

export function MinStdItemGathering(props: MinStdIndicatorGatheringProps) {
  const { indicator, authorId, startYear, endYear } = props;
  const [value, setValue] = useState<string | null>(String(endYear));

  if (!indicator.splitByYear) {
    return (
      <MinStdItemYearGathering
        year={null}
        indicator={indicator}
        authorId={authorId}
        hasAddAll={indicator.autoAddAll}
      />
    );
  }

  const items = range(startYear, endYear)
    .map(y => String(y))
    .reverse()
    .map(year => (
      <Accordion.Item
        key={year}
        value={year}
      >
        <Accordion.Control>
          {indicator.formattedIndicatorCode} - {year}
        </Accordion.Control>
        <Accordion.Panel>
          {value === year && (
            <Suspense
              key={year}
              fallback={<PendingSpinner h="370px" />}
            >
              <MinStdItemYearGathering
                year={Number(year)}
                indicator={indicator}
                authorId={authorId}
                hasAddAll={indicator.autoAddAll}
              />
            </Suspense>
          )}
        </Accordion.Panel>
      </Accordion.Item>
    ));

  return (
    <Accordion
      variant="separated"
      value={value}
      onChange={setValue}
    >
      {items}
    </Accordion>
  );
}
